const router = [
  {
    path: '/kfqg',
    name: 'kfqg',
    component: () => import('./kfqg'),
  },
  {
    path: '/zwyq',
    name: 'zwyq',
    component: () => import('./zwyq'),
  },
  {
    path: '/yqjc',
    name: 'yqjc',
    component: () => import('./yqjc'),
  },
  {
    path: '/ssw',
    name: 'ssw',
    component: () => import('./ssw'),
  },
  {
    path: '/gxcj',
    name: 'gxcj',
    component: () => import('./gxcj'),
  },
  {
    path: '/twwt',
    name: 'twwt',
    component: () => import('./twwt'),
  },
  {
    path: '/jingjinji',
    name: 'jingjinji',
    component: () => import('./jingjinji'),
  },
  {
    path: '/gxh',
    name: 'gxh',
    component: () => import('./gxh'),
  },
]

export default router
